import { useQuery } from 'react-query';
import { GetAllBoostHistoryResponse, UseAllBoostsHistoryOptions } from './useAllBoostsHistory.types';
import { allBoostsHistoryQuery } from './useAllBoostsHistory.query';
import { GetAllBoostHistoryQueryParams } from '../../../types/api/endpoints/boost/history.types';

export const ALL_BOOSTS_HISTORY_QUERY_KEY = 'ALL_BOOSTS_HISTORY';

export const useAllBoostsHistory = (params: GetAllBoostHistoryQueryParams, options?: UseAllBoostsHistoryOptions) => {
  return useQuery<GetAllBoostHistoryResponse, Error>(
    [ALL_BOOSTS_HISTORY_QUERY_KEY, params],
    () => allBoostsHistoryQuery(params),
    options
  );
};
